export function printAgreementPdf(htmlAgreement, clientName) {
  const fmt = (d) => d
    ? new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    : '';

  const coachDate = fmt(htmlAgreement.coachSignedDate);
  const sigName = htmlAgreement.signed ? (htmlAgreement.signedName || clientName || '') : '';
  const clientDate = htmlAgreement.signed ? fmt(htmlAgreement.signedDate) : '';

  const win = window.open('', '_blank', 'width=900,height=700');

  win.document.write(`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Coaching Agreement</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <style>
    @page { margin: 0.9in; size: letter; }
    * { box-sizing: border-box; }
    body {
      font-family: 'Inter', system-ui, -apple-system, sans-serif;
      font-size: 13px; color: #374151; line-height: 1.65; margin: 0;
    }

    /* ── Contract document styles (mirrors App.css .contract-doc) ── */
    .contract-doc { font-family: inherit; }
    .contract-title {
      text-align: center; font-size: 18px; font-weight: 700;
      color: #111827; margin-bottom: 0.2rem;
    }
    .contract-title::after {
      content: ''; display: block; width: 40px; height: 3px;
      background: #1e3a8a; border-radius: 2px; margin: 0.4rem auto 0;
    }
    .contract-date {
      text-align: center; font-size: 12px; color: #6b7280; margin-bottom: 1.5rem;
    }
    .contract-parties {
      background: #f8faff; border: 1px solid #dbeafe;
      border-radius: 8px; padding: 1rem 1.25rem; margin-bottom: 1.25rem;
    }
    h2 {
      font-size: 10px; font-weight: 700; color: #1e3a8a;
      text-transform: uppercase; letter-spacing: 0.13em;
      margin: 1.5rem 0 0.5rem; border: none;
    }
    p { margin: 0.35rem 0; }
    table { width: 100%; border-collapse: separate; border-spacing: 6px; }
    th, td { padding: 0.45rem 0.7rem; font-size: 12px; }
    th { background: #f9fafb; font-weight: 600; border-radius: 6px; }
    strong { font-weight: 600; }
    em.contract-tbd { color: #9ca3af; font-style: italic; }

    /* ── Signature block ── */
    .sig-block {
      display: grid; grid-template-columns: 1fr 1fr; gap: 1.5rem;
      margin-top: 2.5rem; padding-top: 1.5rem; border-top: 2px solid #e5e7eb;
      page-break-inside: avoid;
    }
    .sig-party {
      background: #f9fafb; border: 1px solid #e5e7eb;
      border-radius: 8px; padding: 0.9rem 1.1rem;
    }
    .sig-label {
      font-size: 10px; font-weight: 700; text-transform: uppercase;
      letter-spacing: 0.08em; color: #6b7280; margin: 0 0 0.4rem;
    }
    .sig-name { font-size: 1rem; font-weight: 600; color: #111827; margin: 0 0 0.25rem; }
    .sig-signed { font-size: 11px; color: #166534; margin: 0; }
    .sig-pending { font-size: 11px; color: #9ca3af; font-style: italic; margin: 0; }

    @media print {
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  </style>
</head>
<body>
  ${htmlAgreement.html}

  <div class="sig-block">
    <div class="sig-party">
      <p class="sig-label">NextLeader Coaching (Coach)</p>
      <p class="sig-name">Irwin Tran — Owner</p>
      <p class="sig-signed">✓ Signed${coachDate ? ' ' + coachDate : ''}</p>
    </div>
    <div class="sig-party">
      <p class="sig-label">Client</p>
      ${sigName ? `<p class="sig-name">${sigName}</p>` : ''}
      ${htmlAgreement.signed
        ? `<p class="sig-signed">✓ Signed${clientDate ? ' ' + clientDate : ''}</p>`
        : `<p class="sig-pending">Pending signature</p>`}
    </div>
  </div>

  <script>
    // Wait for the Google Font to load before printing
    document.fonts.ready.then(function() { window.print(); });
    window.onafterprint = function() { window.close(); };
  </script>
</body>
</html>`);

  win.document.close();
}
